var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-headline"
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeText,
          closeEdit: _vm.initCurrentData
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-headline-content",
                      class: [
                        _vm.currentStyle,
                        _vm.currentHeight === "half" ? "half" : "full"
                      ],
                      style: _vm.headlineStyle
                    },
                    [
                      _c("div", {
                        staticClass: "icon-layer",
                        class: [
                          "icon-" +
                            _vm.currentIconColor +
                            "-" +
                            _vm.currentIcon,
                          _vm.currentHeight === "half" ? "half" : "full"
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-headline-textbox"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-headline-title"
                            },
                            [
                              _c(
                                "h1",
                                {
                                  style: _vm.textStyle
                                },
                                [_vm._v(_vm._s(_vm.currentTitle))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-headline-subtitle"
                            },
                            [
                              _c(
                                "h2",
                                {
                                  style: _vm.textStyle
                                },
                                [_vm._v(_vm._s(_vm.currentSubtitle))]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Layout")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentStyle,
                                      expression: "currentStyle"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentStyle = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "heavy"
                                      }
                                    },
                                    [
                                      _c("translate", [_vm._v("Große Schrift")])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "ribbon"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Band")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "bigicon_top"
                                      }
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Großes Icon oben")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "bigicon_before"
                                      }
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Großes Icon davor")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Höhe")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentHeight,
                                      expression: "currentHeight"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentHeight = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "full"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Voll")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "half"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Halb")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Haupttitel")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle"
                                  }
                                ],
                                attrs: {
                                  type: "text"
                                },
                                domProps: {
                                  value: _vm.currentTitle
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasSubtitle
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Untertitel")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.currentSubtitle,
                                        expression: "currentSubtitle"
                                      }
                                    ],
                                    attrs: {
                                      type: "text"
                                    },
                                    domProps: {
                                      value: _vm.currentSubtitle
                                    },
                                    on: {
                                      input: function input($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.currentSubtitle =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Textfarbe")]),
                              _vm._v(" "),
                              _c("studip-select", {
                                attrs: {
                                  options: _vm.colors,
                                  label: "hex",
                                  reduce: function reduce(color) {
                                    return color.hex
                                  },
                                  clearable: false
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: "10"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "no-options",
                                      fn: function fn(_ref) {
                                        var search = _ref.search,
                                          searching = _ref.searching,
                                          loading = _ref.loading
                                        return [
                                          _c("translate", [
                                            _vm._v(
                                              "Es steht keine Auswahl zur Verfügung."
                                            )
                                          ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(_ref2) {
                                        var name = _ref2.name,
                                          hex = _ref2.hex
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": hex
                                            }
                                          }),
                                          _c("span", [_vm._v(_vm._s(name))])
                                        ]
                                      }
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(_ref3) {
                                        var name = _ref3.name,
                                          hex = _ref3.hex
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": hex
                                            }
                                          }),
                                          _c("span", [_vm._v(_vm._s(name))])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1031768167
                                ),
                                model: {
                                  value: _vm.currentTextColor,
                                  callback: function callback($$v) {
                                    _vm.currentTextColor = $$v
                                  },
                                  expression: "currentTextColor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Icon")]),
                              _vm._v(" "),
                              _c("studip-select", {
                                attrs: {
                                  clearable: false,
                                  options: _vm.icons
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: "10"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "no-options",
                                      fn: function fn(_ref4) {
                                        var search = _ref4.search,
                                          searching = _ref4.searching,
                                          loading = _ref4.loading
                                        return [
                                          _c("translate", [
                                            _vm._v(
                                              "Es steht keine Auswahl zur Verfügung."
                                            )
                                          ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(option) {
                                        return [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: option.label
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vs__option-with-icon"
                                            },
                                            [_vm._v(_vm._s(option.label))]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(option) {
                                        return [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: option.label
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vs__option-with-icon"
                                            },
                                            [_vm._v(_vm._s(option.label))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4267087591
                                ),
                                model: {
                                  value: _vm.currentIcon,
                                  callback: function callback($$v) {
                                    _vm.currentIcon = $$v
                                  },
                                  expression: "currentIcon"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Icon-Farbe")]),
                              _vm._v(" "),
                              _c("studip-select", {
                                attrs: {
                                  options: _vm.iconColors,
                                  label: "name",
                                  reduce: function reduce(iconColor) {
                                    return iconColor.class
                                  },
                                  clearable: false
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: "10"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "no-options",
                                      fn: function fn(_ref5) {
                                        var search = _ref5.search,
                                          searching = _ref5.searching,
                                          loading = _ref5.loading
                                        return [
                                          _c("translate", [
                                            _vm._v(
                                              "Es steht keine Auswahl zur Verfügung."
                                            )
                                          ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(_ref6) {
                                        var name = _ref6.name,
                                          hex = _ref6.hex
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": hex
                                            }
                                          }),
                                          _c("span", [_vm._v(_vm._s(name))])
                                        ]
                                      }
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(_ref7) {
                                        var name = _ref7.name,
                                          hex = _ref7.hex
                                        return [
                                          _c("span", {
                                            staticClass: "vs__option-color",
                                            style: {
                                              "background-color": hex
                                            }
                                          }),
                                          _c("span", [_vm._v(_vm._s(name))])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1031768167
                                ),
                                model: {
                                  value: _vm.currentIconColor,
                                  callback: function callback($$v) {
                                    _vm.currentIconColor = $$v
                                  },
                                  expression: "currentIconColor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Hintergrundtyp")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentBackgroundType,
                                      expression: "currentBackgroundType"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentBackgroundType = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "color"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Farbe")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "image"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Bild")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.currentBackgroundType === "color"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Hintergrundfarbe")]),
                                  _vm._v(" "),
                                  _c("studip-select", {
                                    attrs: {
                                      options: _vm.colors,
                                      label: "hex",
                                      reduce: function reduce(color) {
                                        return color.hex
                                      },
                                      clearable: false
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "open-indicator",
                                          fn: function fn(selectAttributes) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._b(
                                                  {},
                                                  "span",
                                                  selectAttributes,
                                                  false
                                                ),
                                                [
                                                  _c("studip-icon", {
                                                    attrs: {
                                                      shape: "arr_1down",
                                                      size: "10"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "no-options",
                                          fn: function fn(_ref8) {
                                            var search = _ref8.search,
                                              searching = _ref8.searching,
                                              loading = _ref8.loading
                                            return [
                                              _c("translate", [
                                                _vm._v(
                                                  "Es steht keine Auswahl zur Verfügung."
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "selected-option",
                                          fn: function fn(_ref9) {
                                            var name = _ref9.name,
                                              hex = _ref9.hex
                                            return [
                                              _c("span", {
                                                staticClass: "vs__option-color",
                                                style: {
                                                  "background-color": hex
                                                }
                                              }),
                                              _c("span", [_vm._v(_vm._s(name))])
                                            ]
                                          }
                                        },
                                        {
                                          key: "option",
                                          fn: function fn(_ref10) {
                                            var name = _ref10.name,
                                              hex = _ref10.hex
                                            return [
                                              _c("span", {
                                                staticClass: "vs__option-color",
                                                style: {
                                                  "background-color": hex
                                                }
                                              }),
                                              _c("span", [_vm._v(_vm._s(name))])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1031768167
                                    ),
                                    model: {
                                      value: _vm.currentBackgroundColor,
                                      callback: function callback($$v) {
                                        _vm.currentBackgroundColor = $$v
                                      },
                                      expression: "currentBackgroundColor"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentBackgroundType === "image"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Hintergrundbild")]),
                                  _vm._v(" "),
                                  _c("courseware-file-chooser", {
                                    attrs: {
                                      isImage: true
                                    },
                                    on: {
                                      selectFile:
                                        _vm.updateCurrentBackgroundImage
                                    },
                                    model: {
                                      value: _vm.currentBackgroundImageId,
                                      callback: function callback($$v) {
                                        _vm.currentBackgroundImageId = $$v
                                      },
                                      expression: "currentBackgroundImageId"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("translate", [_vm._v("Informationen zum Blickfang-Block")])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }